export default __webpack_public_path__ + "static/media/img-0687-bosnia-premium-face.c780b900.png";